export const GET_ONE_SOLUTION_DETAILS_FOR_AUTH_REQUEST =
  "GET_ONE_SOLUTION_DETAILS_FOR_AUTH_REQUEST";
export const GET_ONE_SOLUTION_DETAILS_FOR_AUTH_SUCCESS =
  "GET_ONE_SOLUTION_DETAILS_FOR_AUTH_SUCCESS";
export const GET_ONE_SOLUTION_DETAILS_FOR_AUTH_FAIL =
  "GET_ONE_SOLUTION_DETAILS_FOR_AUTH_FAIL";
